import {actions as A} from '../constants/actions';

const defaultState = {
  stepData: {},
  loading: false,
  error: false,
  errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.GET_STEP_DATA:
      return {...state, loading: true, error: false, errorMessage: null, stepData: {}};

    case A.GET_STEP_DATA_SUCCESS:
      const keys = Object.keys(payload);
      return (keys.length > 0)
        ? {...state, loading: false, error: false, errorMessage: null, stepData: payload}
        : {...state, loading: false, error: false, errorMessage: null};

    case A.APPEND_SHUMA_STEP_DATA:
      return {...state, loading: false, error: false, errorMessage: null, stepData: {...state.stepData, ...payload}};

    case A.SET_SHUMA_STATUS_TYPE_ID:
      const {shumaStatusTypeID} = payload;
      return {...state, stepData: {...state.stepData, shumaStatusTypeID}};

    case A.GET_STEP_DATA_FAILURE:
      return {...state, loading: false, error: true, errorMessage: payload};

    case A.CLEAR_INSPECTION:
      return {...defaultState};

    case A.UPDATE_CUSTOMERS:
      const {customers} = payload;
      return {...defaultState, stepData: {...state.stepData, customers}};

    default:
      return state;
  }
}

